import {
  registerFormInstance,
  selectTabRootInstanceId,
  unregisterFormInstance,
} from '@app-store'
import { useEffect, useMemo, useRef } from 'react'
import { v4 as uuid } from 'uuid'
import { useAppDispatch, useAppSelector } from '../utils/agent.store'
import {
  registerFormAncestryGetValues,
  unregisterFormAncestryGetValues,
} from './formAncestry.registry'
import { FormAncestryScopeProps } from '../types/formBehavior.types'

export const FormAncestryScope = ({
  entityName,
  layoutUid,
  getValues,
  isRootInstance = false,
  children,
}: FormAncestryScopeProps) => {
  const dispatch = useAppDispatch()
  const tabRootInstanceId = useAppSelector(selectTabRootInstanceId)
  const formInstanceId = useMemo(() => uuid(), [])
  const ancestryRegisteredRef = useRef(false)

  const canRegisterRoot = isRootInstance && !tabRootInstanceId
  const canRegisterChild = !isRootInstance && !!tabRootInstanceId
  const shouldRegister = canRegisterRoot || canRegisterChild

  if (entityName && ancestryRegisteredRef.current) {
    registerFormAncestryGetValues(formInstanceId, getValues)
  }

  useEffect(() => {
    if (!entityName || !shouldRegister) return

    dispatch(
      registerFormInstance(
        isRootInstance
          ? {
              instanceId: formInstanceId,
              entityName,
              layoutUid,
              setAsTabRoot: true,
            }
          : {
              instanceId: formInstanceId,
              entityName,
              layoutUid,
              registerAsTabChild: true,
            }
      )
    )
    registerFormAncestryGetValues(formInstanceId, getValues)
    ancestryRegisteredRef.current = true

    return () => {
      if (!ancestryRegisteredRef.current) return
      dispatch(unregisterFormInstance(formInstanceId))
      unregisterFormAncestryGetValues(formInstanceId)
      ancestryRegisteredRef.current = false
    }
  }, [])

  return children
}
